import moment from "moment";

export const formatIncidentDuration = (since: string): string => {
  const start = moment(since);
  if (!start.isValid()) {
    return "";
  }

  const duration = moment.duration(moment().diff(start));
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();

  const parts: string[] = [];
  if (days > 0) {
    parts.push(`${days} дн`);
  }
  if (hours > 0) {
    parts.push(`${hours} ч`);
  }
  if (days === 0 && minutes > 0) {
    parts.push(`${minutes} мин`);
  }

  return parts.length > 0
    ? `длится ${parts.join(" ")}`
    : "длится меньше минуты";
};
